/* Supplement only: native variant requests and cache stay in charge. */
(() => {
  if (window.mareldKaufhilfeV1) return;
  window.mareldKaufhilfeV1 = true;
  const sizeName = name => /^(größe|größen|groesse|size)$/i.test((name || '').trim());
  const normalize = value => (value || '').trim().toLowerCase().replace(/,/g, '.').replace(/\s+/g, ' ')
    .replace(/^(universal|one size|onesize|uni|einheitsgröße)$/, 'onesize')
    .replace(/^(xxs|xxxs|xxl|xxxl|xxxxl|xxxxxl|xxxxxxl)$/, label => ({xxs:'2xs',xxxs:'3xs',xxl:'2xl',xxxl:'3xl',xxxxl:'4xl',xxxxxl:'5xl',xxxxxxl:'6xl'}[label]));
  const display = value => normalize(value) === 'onesize' ? 'Einheitsgröße' : value;
  const sizeHeading = name => /^(größe|größen|groesse|size|rozmiar)(?:\s*\([^)]*\))?$/i.test(name.trim());
  function sizeChoices(picker) {
    return [...picker.querySelectorAll('input[type="radio"][data-option-name], select option[data-option-name]')]
      .filter(input => sizeName(input.dataset.optionName));
  }
  function findChoice(picker, label) {
    const matches = sizeChoices(picker).filter(input => normalize(input.value) === normalize(label));
    if (matches.length !== 1) return null;
    const input = matches[0];
    // Combined-product options must not navigate to a different product from this table.
    if (input.dataset.productUrl && input.dataset.productUrl !== picker.dataset.url) return null;
    return input;
  }
  function choiceUnavailable(picker, input) {
    const cache = picker.querySelector('[data-variants-cache]');
    if (cache?.dataset.complete === 'true') {
      try {
        const variants = JSON.parse(cache.textContent);
        const selected = [...picker.querySelectorAll('input:checked,select option:checked')];
        const position = selected.findIndex(value => value.dataset.optionName === input.dataset.optionName);
        if (position >= 0 && variants.length && variants.every(variant => variant.options?.length === selected.length)) {
          const exact = variants.filter(variant => variant.options.every((value, i) => value === (i === position ? input.value : selected[i].value)));
          return !exact.some(variant => variant.available);
        }
      } catch (_) { /* Native availability remains the fallback for incomplete data. */ }
    }
    return input.disabled || input.classList.contains('disabled');
  }
  function update() {
    document.querySelectorAll('.mkh-modal[data-mkh-section]').forEach(modal => {
      const picker = document.getElementById(`variant-selects-${modal.dataset.mkhSection}`);
      if (!picker) return;
      let selected = '';
      picker.querySelectorAll('input:checked,select option:checked').forEach(input => {
        if (sizeName(input.dataset.optionName)) selected = input.value;
      });
      picker.querySelectorAll('[data-selected-swatch-value]').forEach(label => {
        if (sizeName(label.dataset.selectedSwatchValue)) {
          const next = display(label.textContent.trim());
          if (label.textContent.trim() !== next) label.textContent = next;
        }
      });
      modal.querySelectorAll('.mkh-table').forEach(table => {
        const heads = [...table.querySelectorAll('thead th')];
        // The complete product size has priority. Cup and bottom-size columns are never selectors.
        let sizeColumn = heads.findIndex(head => sizeHeading(head.textContent));
        if (sizeColumn < 0) sizeColumn = heads.findIndex(head => /^eu(?:\s*\([^)]*\))?$/i.test(head.textContent.trim()));
        if (sizeColumn < 0) return;
        table.querySelectorAll('tbody tr').forEach(row => {
          const cell = row.cells[sizeColumn];
          if (!cell) return;
          let button = cell.querySelector('button[data-mkh-size]');
          const label = button?.dataset.mkhSize ?? cell.textContent.trim();
          const choice = findChoice(picker, label);
          const match = selected !== '' && normalize(label) === normalize(selected);
          row.classList.toggle('mkh-selected', match);
          if (!choice) {
            if (button) cell.textContent = label;
            return;
          }
          if (!button) {
            button = document.createElement('button');
            button.type = 'button';
            button.className = 'mkh-size-choice';
            button.dataset.mkhSize = label;
            const text = document.createElement('span');
            text.className = 'mkh-size-label';
            text.textContent = label;
            const status = document.createElement('span');
            status.className = 'mkh-size-status';
            status.setAttribute('aria-hidden', 'true');
            button.append(text, status);
            cell.replaceChildren(button);
          }
          const unavailable = choiceUnavailable(picker, choice);
          // Visually sold-out radio options remain selectable for the native restock flow.
          button.disabled = choice.disabled || (choice.tagName === 'OPTION' && choice.parentElement.disabled);
          button.setAttribute('aria-pressed', String(match));
          button.setAttribute('aria-label', `Größe ${display(choice.value)} auswählen${unavailable ? ' – aktuell nicht verfügbar' : ''}`);
          button.classList.toggle('mkh-size-unavailable', unavailable);
          const status = button.querySelector('.mkh-size-status');
          const statusText = unavailable ? 'Nicht verfügbar' : '';
          if (status.textContent !== statusText) status.textContent = statusText;
        });
      });
    });
  }
  document.addEventListener('click', event => {
    const button = event.target.closest?.('button[data-mkh-size]');
    const modal = button?.closest('basic-modal.mkh-modal');
    if (!modal || button.disabled) return;
    const picker = document.getElementById(`variant-selects-${modal.dataset.mkhSection}`);
    const choice = picker && findChoice(picker, button.dataset.mkhSize);
    if (!choice || choice.disabled) return;
    event.preventDefault();
    let changed = false;
    let target = choice;
    if (choice.tagName === 'OPTION') {
      target = choice.parentElement;
      if (target.disabled) return;
      changed = target.value !== choice.value;
      target.value = choice.value;
    } else {
      changed = !choice.checked;
      choice.checked = true;
    }
    // Let Pillar update variant ID, inventory, media, price and cart readiness normally.
    if (changed) target.dispatchEvent(new Event('change', { bubbles: true }));
    update();
    let status = modal.querySelector('.mkh-choice-feedback');
    if (!status) {
      status = document.createElement('p');
      status.className = 'mkh-selection mkh-choice-feedback';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      modal.querySelector('.drawer__body').prepend(status);
    }
    status.textContent = `Größe ${display(choice.value)} ausgewählt. Du kannst die Größenhilfe jetzt schließen.`;
    schedule();
  });
  // Native BasicModal finds controls globally by ID. A variant render can leave an
  // open instance in <body> while inserting its replacement with the same ID.
  // Capture our controls once and address the actual instance instead of toggling both.
  const modalQueues = new WeakMap();
  const preparedModals = new WeakSet();
  const modals = () => [...document.querySelectorAll('basic-modal.mkh-modal')];
  function prepareModal(modal) {
    if (preparedModals.has(modal)) return;
    preparedModals.add(modal);
    // Preserve the native lifecycle (focus, body lock, restore location and events).
    // transitionend alone is insufficient when motion is disabled or interrupted.
    const transition = action => new Promise(resolve => {
      const overlay = modal.querySelector('.fixed-overlay');
      let timer;
      let finished = false;
      const finish = event => {
        if (event && event.target !== overlay) return;
        if (finished) return;
        finished = true;
        clearTimeout(timer);
        overlay?.removeEventListener('transitionend', finish);
        resolve();
      };
      overlay?.addEventListener('transitionend', finish);
      action();
      const style = overlay ? getComputedStyle(overlay) : null;
      const milliseconds = value => value.endsWith('ms') ? parseFloat(value) : parseFloat(value) * 1000;
      const durations = style?.transitionDuration.split(',').map(value => milliseconds(value.trim())) || [0];
      const delays = style?.transitionDelay.split(',').map(value => milliseconds(value.trim())) || [0];
      const duration = Math.max(0, ...durations.map((value, i) => value + delays[i % delays.length]));
      timer = setTimeout(finish, Math.min(2000, Math.max(80, duration + 100)));
    });
    modal.handleShowTransition = () => new Promise(resolve => {
      setTimeout(() => transition(() => modal.setAttribute('active', '')).then(resolve), 100);
    });
    modal.handleHideTransition = () => transition(() => modal.removeAttribute('active'));
  }
  function operate(modal, action, opener = null) {
    prepareModal(modal);
    const pending = (modalQueues.get(modal) || Promise.resolve()).then(() => {
      if (action === 'show') {
        if (modal.isConnected && !modal.open) return modal.show(opener);
      } else if (modal.open) return modal.hide();
    });
    // A rejected native lifecycle must not block later attempts.
    modalQueues.set(modal, pending.catch(() => {}));
    return pending;
  }
  function closeModal(modal) {
    // Also close a duplicate left open by earlier native control bindings.
    modals().filter(candidate => candidate === modal || (candidate.id === modal.id && candidate.open))
      .forEach(candidate => operate(candidate, 'hide'));
  }
  document.addEventListener('click', event => {
    const control = event.target.closest?.('.open-size-chart, .drawer__close-btn, .fixed-overlay');
    if (!control) return;
    const containingModal = control.closest('basic-modal.mkh-modal');
    if (containingModal && !control.classList.contains('open-size-chart')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      closeModal(containingModal);
      return;
    }
    if (!control.classList.contains('open-size-chart')) return;
    const id = control.getAttribute('aria-controls');
    const matches = modals().filter(modal => modal.id === id);
    // Prefer the current variant's instance over an older instance appended to body.
    const modal = matches.find(candidate => {
      const holder = candidate.closest('[id^="SizeChart-"]');
      return holder && holder.style.display !== 'none';
    }) || matches.find(candidate => candidate.open) || matches[matches.length - 1];
    if (!modal) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    matches.filter(candidate => candidate !== modal && candidate.open).forEach(candidate => operate(candidate, 'hide'));
    operate(modal, 'show', control);
    schedule();
  }, true);
  document.addEventListener('keyup', event => {
    if (event.code !== 'Escape' && event.key !== 'Escape') return;
    const opened = modals().filter(modal => modal.open);
    if (!opened.length) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    closeModal(opened[opened.length - 1]);
  }, true);
  let scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; update(); });
  }
  document.addEventListener('change', schedule);
  document.addEventListener('click', event => { if (event.target.closest('.open-size-chart')) schedule(); });
  document.addEventListener('shopify:section:load', schedule);
  // The native picker replaces section HTML on variant changes. Ignore our own row classes.
  new MutationObserver(records => {
    if (records.some(record => record.type === 'childList')) schedule();
  }).observe(document.documentElement, {childList:true,subtree:true});
  schedule();
})();